<template>
  <div class="animated fadeIn comingsoon">
    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <div class="float-right">
              <i class="cui-credit-card"></i>
            </div>
            <p class="mb-0">Cổ phiếu</p>
            <h1 class="mb-0">{{ stockTotal | numberFormat }}</h1>
          </b-card-body>
          <card-line1-chart-example chartId="card-chart-01" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>

      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <div class="float-right">
              <i class="icon-user"></i>
            </div>
            <p class="mb-0">Thành viên</p>
            <h1 class="mb-0">{{ userTotal | numberFormat }}</h1>
          </b-card-body>
          <card-line2-chart-example chartId="card-chart-01" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>

      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <div class="float-right">
              <i class="icon-user"></i>
            </div>
            <p class="mb-0">Quản trị viên</p>
            <h1 class="mb-0">{{ adminTotal | numberFormat }}</h1>
          </b-card-body>
          <card-line3-chart-example chartId="card-chart-01" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>

      <b-col sm="6">
        <Callout variant="info">
          <small class="text-primary">Hoạt động</small>
          <template v-if="logs">
            <template v-for="log in logs">
              <br><small class="text-muted">{{ log.title }}</small>
            </template>
          </template>

        </Callout>
      </b-col>


    </b-row>
  </div>
</template>

<script>
import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
import CardLine2ChartExample from './dashboard/CardLine2ChartExample'
import CardLine3ChartExample from './dashboard/CardLine3ChartExample'
import { Callout } from '@coreui/vue'
import axios from 'axios'
import {isAuth} from '@/utils/auth'

export default {
  name: 'dashboard',
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
  },
  data: function () {
    return {
      stockTotal: 0,
      userTotal: 0,
      adminTotal: 0,
      logs: [],
    }
  },
  mounted() {
    if (!isAuth()) {
      this.$router.push("/login");
    }
    this.fetchData()

  },
  methods: {
    async fetchData() {
      try {
        // Lấy token từ cookies
        const token = this.$cookies.get('token');

        // Gửi yêu cầu API bằng Axios và đưa token vào header
        const {data:stockTotal} = await axios.get(this.$configs.api + '/api/v1/cp/stocks/count', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (stockTotal > 0) {
          this.stockTotal = stockTotal
        }


        // Gửi yêu cầu API bằng Axios và đưa token vào header
        const {data:userTotal} = await axios.get(this.$configs.api + '/api/v4/cp/users/count', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (userTotal > 0) {
          this.userTotal = userTotal
        }

        // Gửi yêu cầu API bằng Axios và đưa token vào header
        const {data: adminTotal} = await axios.get(this.$configs.api + '/api/v4/cp/admin/count', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (adminTotal > 0) {
          this.adminTotal = adminTotal
        }

        // Gửi yêu cầu API bằng Axios và đưa token vào header
        const {data: logs} = await axios.get(this.$configs.api + '/api/cp/logs?pageSize=5&sort=-createdAt', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        if (logs && logs.rows) {
          this.logs = logs.rows
        }

      } catch (err) {
        console.log(err);
      }
    }
  },
  filters: {
    numberFormat(val) {
      const numberValue = parseFloat(val);
      if (isNaN(numberValue)) {
        return 0;
      }
      return numberValue.toLocaleString();
    }

  }

}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>

